var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 177,
    viewBox: "0 0 168 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2792 137.079L158.963 135.067L150.283 125.404C144.899 119.417 141.863 111.692 141.733 103.636L141.188 70.1036C140.788 45.2133 120.269 25.3609 95.3851 25.7777C70.4947 26.1778 50.6424 46.6968 51.0592 71.5807L51.593 103.839C51.7087 111.31 49.3195 118.615 44.8068 124.559L35.3022 137.089L35.2792 137.079Z",
    fill: "#00A90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1065 31.8692L87.8583 16.6428C87.8107 13.7222 90.141 11.3329 93.0438 11.2855L94.611 11.26C97.5316 11.2124 99.9209 13.5427 99.9683 16.4455L100.216 31.6719C100.264 34.5925 97.9337 36.9819 95.0309 37.0292L93.4638 37.0547C90.5431 37.1023 88.1538 34.7721 88.1065 31.8692Z",
    fill: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.46c9adb4e6e030bf671de36e89a40984.svg";
export { ForwardRef as ReactComponent };